import React, { useState } from 'react';

import Icon from '../atom/Icon';
import { Text } from '../atom/Text';
import { Flex, GreyContainer } from '../atom/Layout';
import { Copyright } from '../atom/Copyright';
import { AnchorToKakaoCs } from '../atom/Anchor';
import { TextLinkWithVerticalLine } from '../molecules/TextLink';

import * as PATH from '../../../lib/routes/path';
import ThemeStyle, { SizeToRem } from '../../../lib/style/ThemeStyle';
import { INFO_ROUTE } from '../../../lib/routes/InfoPageRoutes';

const Footer = () => {
  return (
    <Flex
      column
      padding={
        [PATH.SALES, PATH.SALES_CLEARFACE].includes(window.location.pathname)
          ? '0 0 2.1rem'
          : 0
      }
      width="100%"
      style={{ backgroundColor: ThemeStyle.background.white }}
    >
      <AlethioCsContainer title={ALETHIO_CS_CONTENT.title}>
        <Text color="darkest" size="12" style={{ lineHeight: 'calc(20em/12)' }}>
          {ALETHIO_CS_CONTENT.content[0]}{' '}
          <AnchorToKakaoCs>
            <b>{ALETHIO_CS_CONTENT.content[1]}</b>
          </AnchorToKakaoCs>
          {ALETHIO_CS_CONTENT.content[2]}
          {ALETHIO_CS_CONTENT.content[3]}
        </Text>
      </AlethioCsContainer>
      <TextLinkWithVerticalLine
        list={ALETHIO_INTRO}
        style={{ margin: 'calc(20em/14) 0' }}
      />

      <AlethioInfoContainer
        title={ALETHIO_INFO.title}
        list={ALETHIO_INFO.list}
      />
      <Copyright style={{ margin: `${SizeToRem(40)} 0 ${SizeToRem(55)} ` }} />
    </Flex>
  );
};
export default React.memo(Footer);

const ALETHIO_CS_CONTENT = {
  title: '고객센터',
  content: [
    '카카오톡 채널',
    "'베이비페이스 고객센터'",
    '에서 상담(10:00 -18:00 | 토, 일, 공휴일 휴무)',
    ' 이메일 문의 : cs@alethio.io',
  ],
};

const ALETHIO_INFO = {
  title: '주식회사 알레시오 사업자정보',
  list: [
    {
      label: '상호명',
      content: '알레시오 주식회사',
    },
    {
      label: '대표',
      content: '김다운',
    },
    {
      label: '주소',
      content: '서울특별시 강남구 테헤란로82길 15, (대치동, 디아이타워) 1518호',
    },
    {
      label: '사업자번호',
      content: '663-87-00549',
    },
    {
      label: '통신판매업신고',
      content: '2019-서울서초-3220호',
    },
    {
      label: '개인정보관리자',
      content: '최광민',
    },
    {
      label: '마케팅/제휴 문의',
      content: 'cs@alethio.io',
    },
    {
      label: '상품/서비스 문의',
      content: 'cs@alethio.io',
    },
    {
      label: '고객센터',
      content: <>카카오톡 채널 <a href="http://pf.kakao.com/_xokYNK/chat" target="blank" rel="noopener noreferrer"><b>'베이비페이스 고객센터'</b></a></>,
    },
  ],
};

const ALETHIO_INTRO = [
  {
    text: '회사소개',
    link: 'https://alethio.io/',
  },
  { text: INFO_ROUTE[0].title, link: INFO_ROUTE[0].path },
  { text: INFO_ROUTE[1].title, link: INFO_ROUTE[1].path },
];

const AlethioCsContainer = ({ title, children }) => (
  <GreyContainer column alignItems="flex-start">
    <Text color="darkest" size="14" style={{ marginBottom: 'calc(5em/14)' }}>
      {title}
    </Text>
    {children}
  </GreyContainer>
);

const AlethioInfoContainer = ({
  title = '',
  list = [{ label: '', content: '' }],
}) => {
  const [isToggleOpen, setIsToggleOpen] = useState(true);
  return (
    <>
      <Flex justifyContent="space-between" padding={`${SizeToRem(20)} 0`}>
        <Text color="darkest" size="12">
          {title}
        </Text>
        <Icon
          iconName={isToggleOpen ? 'expand_less' : 'expand_more'}
          onClick={() => setIsToggleOpen(!isToggleOpen)}
        />
      </Flex>
      {isToggleOpen && (
        <GreyContainer column>
          {list.map((info) => (
            <Flex
              key={info.label}
              justifyContent="space-between"
              style={{ width: '100%', marginBottom: '0.3rem' }}
            >
              {[
                { flex: '0.95', text: info.label },
                { flex: '2.3', text: info.content },
              ].map((text) => (
                <Text
                  key={text.flex}
                  size="10"
                  style={{ flex: text.flex, lineHeight: '1rem' }}
                  color="caption"
                >
                  {text.text}
                </Text>
              ))}
            </Flex>
          ))}
        </GreyContainer>
      )}
    </>
  );
};
